<template>
	<div>
		<h3 class="marginB12">推广码统计</h3>
		<div class="flexB">
			<div class="flexA marginR10">
				<el-select v-model="pushData.merchantId" style="width: 260px;" @change="getMerchantId" placeholder="商户" clearable class="marginR10">
					<el-option style="max-width: 260px;" v-for="item in merchantList" :key="item.id"
						:label='item.name' :value="item.id"></el-option>
				</el-select>
				<el-select v-model="pushData.shopId" style="width: 260px;" @change="search()" placeholder="全部门店" clearable class="marginR10">
					<el-option style="max-width: 260px;" v-for="item in shopList" :key="item.id"
						:label='item.name' :value="item.id"></el-option>
				</el-select>
				<!-- <el-select v-model="pushData.subscribe" placeholder="状态" @change="search()" class="marginR10">
					<el-option v-for="item in statusList" :key="item.status"
						:label='item.name' :value="item.status"></el-option>
				</el-select> -->
				<el-input placeholder="搜索会员名称" v-model="pushData.fuzzySearch" @keyup.enter="search()" style="width: 200px;">
					<template #suffix>
						<el-icon class="el-input__icon">
							<component :is="Search" class="enter-sj" @click="search()"></component>
						</el-icon>
					</template>
				</el-input>
			</div>
			<div>
			<!-- <div style="padding: 6px 10px;border: 1px solid gainsboro;border-radius: 6px;"> -->
				<el-dropdown>
					<el-button type="primary" plain color="#112DF2">
					    更多操作<el-icon class="el-icon--right"><arrow-down /></el-icon>
					</el-button>
				    <template #dropdown>
				      <el-dropdown-menu>
				        <el-dropdown-item @click.native="importData">批量导出</el-dropdown-item>
				      </el-dropdown-menu>
				    </template>
				  </el-dropdown>
			</div>
		</div>
		<el-table :data="tableData" :empty-text="emptyText" style="width: 100%;margin-top: 30px;">
			<el-table-column prop="merchantName" label="商户名称" />
		    <el-table-column prop="shopName" label="门店名称" />
			<el-table-column prop="customerNickName" label="微信昵称" />
			<el-table-column prop="customerPhoneNumber" label="手机号码" />
			<el-table-column prop="spreadUnitPrice" label="推广单价" />
			<el-table-column prop="createdTime" label="注册时间" />
			<!-- <el-table-column prop="subscribe" label="状态">
				<template #default="{row}">
					<div>{{row.subscribe?'已关注':'取消关注'}}</div>
				</template>
			</el-table-column> -->
		</el-table>
		<div class="relativeB">
			<div class='absoluteB'>
			  <el-dropdown placement='top'>
			    <el-button type="warning" size='mini'>
			      统计数据<el-icon class="el-icon--right"><arrow-down /></el-icon>
			    </el-button>
				<template #dropdown>
				  <el-dropdown-menu>
				    <el-dropdown-item>推广数: {{wechatMpUserCount || 0}}</el-dropdown-item>
				  </el-dropdown-menu>
				</template>
			  </el-dropdown>
			</div>
			<div class="paginations">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize" layout="prev, pager, next" :total="total">
				</el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import {merchantSpreadWechatMaQrcodePageList,shopList,merchantList,merchantSpreadWechatMaExport} from '@/api'
	import {formatDateOrder,dateFormat} from '@/utils/data'
	import { Search } from "@element-plus/icons-vue";
	export default {
		data () {
			return {
				Search,
				statusList:[
					{name:'全部',status:'all'},
					{name:'已关注',status:true},
					{name:'取消关注',status:false},
				],
				wechatMpUserCount:0,
				pushData:{
					fuzzySearch:'',
					shopId:'',
					merchantId:''
				},
				merchantId:'',
				tableData:[],
				merchantList:[],
				shopList:[],
				pageSize: 10,	
				pageNum: 1,
				total:0,
				emptyText:'暂无数据'
			}
		},
		computed:{
			tCountData () {
			  // const data = this.countData
			  return [
			    {label: '推广数', value: '0'}
			  ]
			}
		},
		created() {
			this.getMerchantList()
			this.search()
		},	
		methods:{
			search(){
				let postData = {
					 "paging": {
						"pageNum": this.pageNum,
						"pageSize": this.pageSize
					}
				}
				postData = Object.assign(postData, this.pushData)
				if(postData.subscribe&&(postData.subscribe=='all')){
					delete postData.subscribe
				}
				merchantSpreadWechatMaQrcodePageList(postData).then(res => {
					if(res&&res.success){
						let list = res.data.list
						list.forEach(item=>{
							item.createdTime = formatDateOrder(item.createdTime)
							item.isEdit = false
							item.customerNickNameUp = ''
						})
						this.tableData = list
						this.total = Number(res.data.total)
						this.wechatMpUserCount = Number(res.data.total)
					}
				})
			},
			getMerchantId(){
				let data = this.pushData
				if(data.merchantId == this.merchantId){
					return
				}
				this.pushData.shopId = ''
				this.merchantId = data.merchantId
				this.search()
				if(data.merchantId){
					this.getShopList()
				}else{
					this.shopList = []
				}
			},
			getMerchantList(){
				let postData = {enabled:true}
				merchantList(postData).then(res => {
					if(res&&res.success){
						this.merchantList = res.data
					}
				})
			},
			getShopList(){
				let postData = {enabled:true,merchantId:this.merchantId}
				shopList(postData).then(res => {
					if(res&&res.success){
						this.shopList = res.data
					}
				})
			},
			importData(){//导出
				let postData = {}
				let posts = Object.assign(postData, this.pushData)
				this.$http.post(merchantSpreadWechatMaExport, posts, {
					headers:{
						'Authorization': this.$store.state.userInfo.token?('Bearer'+' '+ this.$store.state.userInfo.token):''
					},
					responseType: "blob"
				}).then(res => {
					const blob = new Blob([res.data], {type: 'application/vnd.ms-excel'});
					const fileName = '商户推广小程序用户列表.xlsx';
					if ('download' in document.createElement('a')) {
						const elink = document.createElement('a');
						elink.download = fileName;
						elink.style.display = 'none';
						elink.href = URL.createObjectURL(blob);
						document.body.appendChild(elink);
						elink.click();
						URL.revokeObjectURL(elink.href);
						document.body.removeChild(elink);
					}else{
						navigator.msSaveBlob(blob, fileName);
					}
				});
			},
			editItem(id,customerNickName,type){
				this.tableData.forEach(item=>{
					if(item.id == id){
						item.isEdit = !item.isEdit
						if(type==1){
							item.customerNickNameUp = customerNickName
						}
					}
				})
				if(type==2){
					updateCustomerNickNameById({data:{id,customerNickName}}).then(res=>{
						if(res&&res.success){
							this.tableData.forEach(item=>{
								if(item.id == id){
									item.customerNickName = customerNickName
								}
							})
						}
					})
				}
			},
			handleSizeChange(val) {
				this.pageSize = val;
				this.search()
			},
			handleCurrentChange(val) {
				this.pageNum = val;
				this.search()
			},
		}
	}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
	.cardCon{
		max-width: 90%;
		margin-bottom: 10px;
	}
	// :deep(.el-select .el-input__wrapper){
	// 	width: 200px;
	// }
	// :deep(.el-icon svg){
	// 	color: #112DF2;
	// 	width: 12px;
	// 	height: 12px;
	// }
	// .el-select-dropdown__item{
	//   padding: 0 20px;
	//   box-sizing: border-box;
	// }
</style>